import { Component, OnInit, NgModule } from '@angular/core';
import { VisitorCounterService } from '../../../services/visitor-counter/visitor-counter.service';

@Component({
  selector: 'app-visitor-counter',
  templateUrl: './visitor-counter.component.html',
  styleUrls: []
})
export class VisitorCounterComponent implements OnInit {
  visitorCount: number = 0;
  lastUpdate: string = '';
  isAnimating = false;

  constructor(private visitorCounterService: VisitorCounterService) {}

  ngOnInit(): void {
    this.visitorCounterService.updateVisitorRecord();
    this.visitorCount = this.visitorCounterService.getVisitorCount();
    this.lastUpdate = this.formatDate(this.visitorCounterService.getLastUpdateTime());
    
    // Subscribe to count changes
    this.visitorCounterService.visitorCount$.subscribe(count => {
      // Add animation class when count changes
      const previousCount = this.visitorCount;
      this.visitorCount = count;
      
      // Trigger animation if count has changed
      if (count !== previousCount) {
        this.triggerCounterAnimation();
      }
    });
  }

  triggerCounterAnimation(): void {
    this.isAnimating = true;
    setTimeout(() => {
      this.isAnimating = false;
    }, 300);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}